export default "__VITE_ASSET__CwedIoUP__"